export const IST_TIMEZONE = "Asia/Kolkata";

const IST_FORMATTED_PATTERN =
    /^\d{4}-\d{2}-\d{2} \d{1,2}:\d{2} (AM|PM)$/i;

/** Format a timestamp for display in IST (12-hour). */
export function formatDateTimeIST(
    value: string | number | Date | null | undefined,
): string {
    if (value === null || value === undefined || value === "") return "-";

    if (typeof value === "string" && IST_FORMATTED_PATTERN.test(value.trim())) {
        return value.trim();
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";

    return date.toLocaleString("en-IN", {
        timeZone: IST_TIMEZONE,
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}
